import { render } from "./EcomMaster.vue?vue&type=template&id=bc67831c"
import script from "./EcomMaster.vue?vue&type=script&lang=js"
export * from "./EcomMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__